import { useState, useEffect } from 'react';

export function useDarkMode() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const calculateTheme = () => {
      const body = document.body;

      if (body.classList.contains('dark-theme')) {
        setIsDark(true);
      } else if (body.classList.contains('light-theme')) {
        setIsDark(false);
      } else {
        setIsDark(mediaQuery.matches);
      }
    };

    calculateTheme();
    mediaQuery.addEventListener('change', calculateTheme);

    const observer = new MutationObserver(calculateTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => {
      mediaQuery.removeEventListener('change', calculateTheme);
      observer.disconnect();
    };
  }, []);

  return isDark;
}
